import { render, staticRenderFns } from "./dialog-verified.vue?vue&type=template&id=3ac8d8dd"
import script from "./dialog-verified.vue?vue&type=script&lang=js"
export * from "./dialog-verified.vue?vue&type=script&lang=js"
import style0 from "./dialog-verified.vue?vue&type=style&index=0&id=3ac8d8dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports